import { webLightTheme } from '@fluentui/react-components';

export const fluentUiTheme = webLightTheme;
